var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("modal", {
        ref: "centerModal",
        attrs: { "sheet-class": "ct-sheet ct-lookup" },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c("h4", [
                  _c("i", { staticClass: "fa fa-gear" }),
                  _vm._v(" Customer Config"),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c("div", { staticClass: "customer-config" }, [
                  _c("div", { staticClass: "row no-gutters" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _c(
                        "div",
                        { staticClass: "border rounded p-3 bg-white" },
                        [
                          _c("div", { staticClass: "icon-grid" }, [
                            _c(
                              "div",
                              {
                                staticClass: "icon-card",
                                attrs: { role: "button", tabindex: "0" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onLinkTo({
                                      type: "application",
                                      context: _vm.modalContext,
                                    })
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-gear fa-3x mb-2",
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "h6 mb-0" }, [
                                  _vm._v("Application Setting"),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "icon-card",
                                attrs: { role: "button", tabindex: "0" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onLinkTo({
                                      type: "company",
                                      context: _vm.modalContext,
                                    })
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-gear fa-3x mb-2",
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "h6 mb-0" }, [
                                  _vm._v("Company Setting"),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "icon-card",
                                attrs: { role: "button", tabindex: "0" },
                                on: {
                                  click: function ($event) {
                                    return _vm.onLinkTo({
                                      type: "document_running",
                                      context: _vm.modalContext,
                                    })
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass: "fa fa-gear fa-3x mb-2",
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "h6 mb-0" }, [
                                  _vm._v("Document Running Setting"),
                                ]),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "footer",
            fn: function () {
              return [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-sm modal-close-btn",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        return _vm.closeModal()
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-times" }),
                    _vm._v(" " + _vm._s(_vm.ui.close) + "\n      "),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }